import { ELEMENT_MODULE_LOAD_CALLBACKS, ELEMENT_MODULE_LOAD_CALLBACKS_AS_ROUTES } from './element-registry';
const ɵ0 = ELEMENT_MODULE_LOAD_CALLBACKS, ɵ1 = ELEMENT_MODULE_LOAD_CALLBACKS_AS_ROUTES;
export class CustomElementsModule {
}
export { ɵ0, ɵ1 };
